<template>
    <div id="nav">
        <CLogo />

        <div id="#tab-bar" class="flex-1"></div>

        <div class="qab">
            <CNotificationIcon />
            <CIncidentIcon />
            <CUpdateIcon />
            <CHelpIcon />
            <CImpersonationIcon />
            <CUser />
        </div>
    </div>
</template>

<script lang="ts" setup>
// import OmniSearch from './omnisearch.vue';
import CHelpIcon from './qab/c-help-icon.vue';
import CImpersonationIcon from './qab/c-impersonation-icon.vue';
import CIncidentIcon from './qab/c-incident-icon.vue';
import CLogo from './qab/c-logo.vue';
import CNotificationIcon from './qab/c-notification-icon.vue';
import CUpdateIcon from './qab/c-update-icon.vue';
import CUser from './qab/c-user.vue';

// global keyboard event listener to open omnisearch
// TODO: clean up, add command+F w/ secondary browser forwarding, use proper selector (or singleton)
// window.addEventListener('keydown', e => {
//     if (e.key === 'k' && e.metaKey) {
//         e.preventDefault();
//         const modalWraps = document.querySelectorAll('.vf-modal-wrap');
//         const omnisearchModalWrap = Array.from(modalWraps).find(mw => mw.id === 'omnisearch');
//         if (omnisearchModalWrap) return;
//         openOmnisearch();
//     }
// });

// async function openOmnisearch() {
//     await presentOverlay(OmniSearch, {});
// }
</script>

<style scoped>
@reference '#tw.css';

#nav {
    @apply flex justify-between items-center;

    .qab {
        @apply flex items-center gap-2;

        i {
            @apply cursor-pointer hover:opacity-50 text-3xl ml-2;
        }

        > :last-child {
            @apply ml-2;
        }
    }
}
</style>

<style>
@reference '#tw.css';

#freshworks-frame-wrapper {
    bottom: inherit !important;
    animation: none !important;
    top: 64px;
}
</style>
